"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var core_1 = require("@material-ui/core");

var withStyles_1 = __importDefault(require("@material-ui/core/styles/withStyles"));

var Table_1 = __importDefault(require("@material-ui/core/Table"));

var TableBody_1 = __importDefault(require("@material-ui/core/TableBody"));

var TableCell_1 = __importDefault(require("@material-ui/core/TableCell"));

var TableHead_1 = __importDefault(require("@material-ui/core/TableHead"));

var TableRow_1 = __importDefault(require("@material-ui/core/TableRow"));

var styles = function styles(theme) {
  return core_1.createStyles({
    root: {
      marginBottom: 30,
      marginTop: 30,
      width: '100%'
    }
  });
};

function BB8SimpleTable(props) {
  var classes = props.classes;
  return react_1.default.createElement(Table_1.default, {
    className: classes.table
  }, react_1.default.createElement(TableHead_1.default, null, react_1.default.createElement(TableRow_1.default, null, props.cols.map(function (_a, index) {
    var title = _a.title;
    return react_1.default.createElement(TableCell_1.default, {
      key: "sub-table-header-cell-" + index
    }, title);
  }))), react_1.default.createElement(TableBody_1.default, null, props.data.map(function (row, i) {
    return react_1.default.createElement(TableRow_1.default, {
      key: "sub-table-header-row-" + i
    }, props.cols.map(function (_a, index) {
      var id = _a.id;
      return react_1.default.createElement(TableCell_1.default, {
        key: "sub-table-header-cell-" + index + "-" + i
      }, row[id]);
    }));
  })));
}

exports.default = withStyles_1.default(styles)(BB8SimpleTable);